import * as Outline from "./Outline";
import React from "react";

const LIBRARIES = {
  outline: Outline,
};

export default function Icon({
  name,
  variant = "outline",
  size = 24,
  color = "currentColor",
  ...props
}) {
  const Component = LIBRARIES[variant]?.[name];

  if (!Component) {
    return null;
  }

  return (
    <Component
      width={size}
      height={size}
      fill={color}
      aria-label={name}
      {...props}
    />
  );
}
